'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactProptypeConditionalRequire = require('react-proptype-conditional-require');

var _reactProptypeConditionalRequire2 = _interopRequireDefault(_reactProptypeConditionalRequire);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WMLink = function WMLink(_ref) {
	var children = _ref.children,
	    href = _ref.href,
	    _onClick = _ref.onClick,
	    style = _ref.style,
	    target = _ref.target;

	return _react2.default.createElement(
		'span',
		null,
		href && _react2.default.createElement(
			'a',
			{
				'data-component-identifier': 'wm-link',
				href: href,
				title: children || href,
				rel: 'noopener noreferrer',
				style: Object.assign({}, _styles2.default.link, style),
				target: target
			},
			children || href
		),
		_onClick && !href && _react2.default.createElement(
			'span',
			{
				'data-component-identifier': 'wm-link',
				tabIndex: 0,
				role: 'link',
				rel: 'noopener noreferrer',
				style: Object.assign({}, _styles2.default.link, style),
				target: target,
				onClick: function onClick(event) {
					return _onClick(event);
				}
			},
			children
		)
	);
};

var EXCLUSIVE_ERROR_MESSAGE = 'You must use either href or the onClick cb prop';

WMLink.defaultProps = {
	target: '_blank'
};

exports.default = WMLink;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMLink/index.js